import { http } from '../utils'


/*
* type: 1: miceCadOea页面; 2: miceCadOeaSchedule页面
* */
const getMiceCadUrl = type => {
  const url = `/minecad?type=${type}`
  return http.get(url)
};

export default {
  getMiceCadUrl,
}
